/* eslint-disable no-mixed-spaces-and-tabs */
import {createStore, applyMiddleware, compose} from 'redux';
// import createSagaMiddleware from 'redux-saga';
import {createEpicMiddleware} from 'redux-observable';
import {BehaviorSubject} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {persistStore, persistReducer} from 'redux-persist';
// import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import storage from 'redux-persist/lib/storage/session';
// import logger from 'redux-logger';

// import appSaga from '../saga/app';
import appEpic from '../epic';
import app from '../redux';

import {createReducerManager} from './reducerManager';

// Build the middleware for intercepting and dispatching navigation actions
// const middleware = routerMiddleware(history);

// create the saga middleware
// const sagaMiddleware = createSagaMiddleware();
const epicMiddleware = createEpicMiddleware({});
export const epic$ = new BehaviorSubject(appEpic);
const rootEpic = (action$, state$, dependencies) =>
  epic$.pipe(mergeMap((epic) => epic(action$, state$, dependencies)));

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
// const store = createStore(
//     combineReducers({
//         reducer,
//         router: routerReducer
//     }),
//     applyMiddleware(middleware),
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(),
// )

// https://github.com/zalmoxisus/redux-devtools-extension#usage
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer =
  process.env.NODE_ENV === 'test'
    ? composeEnhancers(applyMiddleware(epicMiddleware))
    : composeEnhancers(
        // applyMiddleware(sagaMiddleware)
        applyMiddleware(epicMiddleware),
        // applyMiddleware(logger),
      );

const persistConfig = {
  key: 'react-lab',
  storage,
};

const reducerManager = createReducerManager(app);
const rdxRdc = reducerManager.reduce;

const persistedReducer = persistReducer(persistConfig, rdxRdc);

const store = createStore(
  // combineReducers({
  //     app,
  //     router: routerReducer
  // }),
  persistedReducer,
  enhancer,
  // autoRehydrate()
);

store.reducerManager = reducerManager;

persistStore(store);

// then run the saga
// sagaMiddleware.run(appSaga);
epicMiddleware.run(rootEpic);

export default store;
